import React from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import { AuthUser } from 'aws-amplify/auth';
import './Nav.css';

interface Props {
  pickCount: number;
  user: AuthUser | null;
  isAdmin?: boolean;
}

function ShieldIcon() {
  const uid = React.useId().replace(/:/g, '');
  return (
    <svg
      height="38"
      viewBox="168 50 344 422"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ width: 'auto', display: 'block', flexShrink: 0 }}
    >
      <defs>
        <linearGradient id={`sg-${uid}`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#F97316" />
          <stop offset="100%" stopColor="#EC4899" />
        </linearGradient>
        <linearGradient id={`bg-${uid}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#f0e0d0" />
        </linearGradient>
      </defs>
      {/* Glow ring */}
      <path d="M340,52 L512,95 L512,282 Q512,410 340,472 Q168,410 168,282 L168,95 Z"
            fill="none" stroke="#F97316" strokeWidth="3" opacity="0.5" />
      {/* Shield body */}
      <path d="M340,60 L500,100 L500,280 Q500,400 340,460 Q180,400 180,280 L180,100 Z"
            fill="#1a0d00" />
      {/* Shield border */}
      <path d="M340,68 L492,106 L492,279 Q492,393 340,451 Q188,393 188,279 L188,106 Z"
            fill="none" stroke="#F97316" strokeWidth="3" opacity="1" />
      {/* Inner fill */}
      <path d="M340,74 L486,110 L486,278 Q486,387 340,444 Q194,387 194,278 L194,110 Z"
            fill="#0F0A14" />
      {/* Ball */}
      <circle cx="340" cy="210" r="88" fill={`url(#bg-${uid})`} />
      {/* Ball patches */}
      <polygon points="340,145 358,163 351,185 329,185 322,163" fill="#1a0d00" opacity="0.85" />
      <polygon points="390,172 408,190 401,212 379,212 372,190" fill="#1a0d00" opacity="0.85" />
      <polygon points="290,172 308,190 301,212 279,212 272,190" fill="#1a0d00" opacity="0.85" />
      <polygon points="375,235 393,253 386,275 364,275 357,253" fill="#1a0d00" opacity="0.85" />
      <polygon points="305,235 323,253 316,275 294,275 287,253" fill="#1a0d00" opacity="0.85" />
      {/* Stars */}
      <polygon points="300,295 305,310 320,310 308,319 313,334 300,325 287,334 292,319 280,310 295,310"
               fill={`url(#sg-${uid})`} opacity="0.9" />
      <polygon points="340,288 346,306 365,306 350,317 356,335 340,324 324,335 330,317 315,306 334,306"
               fill={`url(#sg-${uid})`} />
      <polygon points="380,295 385,310 400,310 388,319 393,334 380,325 367,334 372,319 360,310 375,310"
               fill={`url(#sg-${uid})`} opacity="0.9" />
    </svg>
  );
}

export default function Nav({ pickCount, user, isAdmin }: Props) {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <nav className="nav">
      <div className="nav-inner container">
        <NavLink to="/" className="nav-logo">
          <ShieldIcon />
          <span className="nav-wordmark">TopQik</span>
        </NavLink>
        <div className="nav-links">
          <NavLink to="/" end className={({ isActive }) => isActive ? 'nav-link nav-hide-mobile active' : 'nav-link nav-hide-mobile'}>
            Home
          </NavLink>
          <NavLink to="/matches" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            Matches
          </NavLink>
          {user && (
            <NavLink to="/my-picks" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
              My Picks
              {pickCount > 0 && <span className="nav-badge">{pickCount}</span>}
            </NavLink>
          )}
          <NavLink to="/leaderboard" className={({ isActive }) => isActive ? 'nav-link nav-hide-mobile active' : 'nav-link nav-hide-mobile'}>
            Leaderboard
          </NavLink>
          {user ? (
            <>
              <NavLink to="/profile" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                Profile
              </NavLink>
              {isAdmin && (
                <NavLink to="/admin" className={({ isActive }) => isActive ? 'nav-link nav-link-admin active' : 'nav-link nav-link-admin'}>
                  Admin
                </NavLink>
              )}
              <button className="nav-signout" onClick={handleSignOut}>Sign Out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link">Sign In</Link>
              <Link to="/login" className="nav-create-btn">Create Account</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
